import { render, staticRenderFns } from "./Plug.vue?vue&type=template&id=75d7bafb&scoped=true&lang=pug&"
import script from "./Plug.vue?vue&type=script&lang=ts&"
export * from "./Plug.vue?vue&type=script&lang=ts&"
import style0 from "./Plug.vue?vue&type=style&index=0&id=75d7bafb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d7bafb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VChip,VProgressLinear})
